import type {ConnectorRoute} from './SiteClientConnector';
export type RecipientCoverage='external'|'justin'|'empty'|'unknown';
export const recipientLabels:Record<RecipientCoverage,string>={external:'Recipient besides Justin',justin:'Justin only',empty:'No configured recipient',unknown:'Route not verified'};
export const recipientColors:Record<RecipientCoverage,string>={external:'#15803d',justin:'#a15c07',empty:'#c62828',unknown:'#8f8f8f'};
export function recipientCoverage(route:ConnectorRoute|undefined):RecipientCoverage{
 if(!route||route.mode==='unchanged')return 'unknown';
 const recipients=route.active_recipients.map(r=>r.trim().toLowerCase()).filter(Boolean);
 if(!recipients.length)return 'empty';
 if(recipients.some(r=>r!=='justin@aryocg.com'))return route.mode==='client_with_internal_copy'?'external':'unknown';
 return 'justin';
}
